import React from 'react'
import { useTranslation } from 'react-i18next'
import { Flame, Scale, Utensils } from 'lucide-react'
import { Card, CardContent } from '../../../../components/ui/card'
import { cn } from '../../../../lib/utils'

const ROWS = [
  { key: 'weight', icon: Scale, color: 'text-app-primary-500' },
  { key: 'meals', icon: Utensils, color: 'text-red-500' },
]

export function LoggingStreaks({ streaks }) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Flame className="w-4 h-4 text-app-primary-500" />
          <h3 className="text-sm font-semibold text-foreground" dir="auto">
            {t('phoenixTracker.analysis.streaks.title')}
          </h3>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {ROWS.map(({ key, icon: Icon, color }) => {
            const s = streaks?.[key]
            const current = s?.current ?? 0
            const best = s?.best ?? 0
            return (
              <div key={key} className="rounded-md bg-muted/40 p-3">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <Icon className={cn('w-3.5 h-3.5', color)} />
                  <span className="text-[11px] text-muted-foreground" dir="auto">
                    {t(`phoenixTracker.analysis.streaks.${key}`)}
                  </span>
                </div>
                <p className="text-xl font-bold font-mono text-foreground" dir="ltr">
                  {current}
                </p>
                <p className="text-[10px] text-muted-foreground font-mono" dir="ltr">
                  {t('phoenixTracker.analysis.streaks.best', { n: best })}
                </p>
              </div>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
